import { useEffect, useState } from "react";
import { domainTags } from "@/mocks/portalData";

const navLinks = [
  { label: "首页", href: "#top" },
  { label: "实时热榜", href: "#hot" },
  { label: "最新爆料", href: "#feed" },
  { label: "大V账号库", href: "#bloggers" },
  { label: "爆料速递", href: "#briefing" },
  { label: "深度专题", href: "#specials" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [showSearch, setShowSearch] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-40">
      <div
        className={`w-full transition-all duration-300 ${
          scrolled
            ? "bg-background-50/90 backdrop-blur-md shadow-[0_1px_0_0_oklch(var(--background-200))]"
            : "bg-background-50/70"
        }`}
      >
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
          <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-lg"></i>
            </span>
            <span className="font-heading text-lg font-bold leading-none tracking-tight text-foreground-950">
              全网爆闻<span className="text-primary-600">站</span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 lg:flex">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="whitespace-nowrap rounded-full px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-200/70 hover:text-foreground-950"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              onClick={() => setShowSearch((s) => !s)}
              aria-label="站内搜索"
              className="flex h-9 w-9 items-center justify-center rounded-full text-foreground-700 transition-colors hover:bg-background-200/70"
            >
              <i className="ri-search-line text-xl"></i>
            </button>
            <a
              href="#faq"
              className="hidden whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
            >
              我要爆料线索
            </a>
            <button
              onClick={() => setOpen((o) => !o)}
              aria-label="打开菜单"
              className="flex h-9 w-9 items-center justify-center rounded-full text-foreground-900 lg:hidden"
            >
              <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
            </button>
          </div>
        </div>

        {showSearch && (
          <div className="border-t border-background-200/80 bg-background-50/95 px-4 py-3 md:px-6">
            <form
              action="#feed"
              className="mx-auto flex max-w-7xl items-center gap-2"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="flex flex-1 items-center gap-2 rounded-full bg-background-100 px-4 py-2">
                <i className="ri-search-line text-lg text-foreground-500"></i>
                <input
                  type="text"
                  placeholder="搜索你关心的爆料话题，例如：综艺、新机、代言…"
                  className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
                />
              </div>
              <a
                href="#feed"
                className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                搜索
              </a>
            </form>
          </div>
        )}

        {open && (
          <div className="border-t border-background-200/80 bg-background-50/95 px-4 py-4 backdrop-blur-md md:px-6 lg:hidden">
            <div className="flex flex-col gap-1">
              {navLinks.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-200/60"
                >
                  {l.label}
                </a>
              ))}
            </div>
            <div className="mt-3 flex flex-wrap gap-2 border-t border-background-200/60 pt-3">
              {domainTags.map((d) => (
                <span
                  key={d.label}
                  className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-100 px-3 py-1.5 text-xs font-medium text-foreground-700"
                >
                  <i className={`${d.icon} text-sm text-primary-600`}></i>
                  {d.label}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </header>
  );
}